import Paper from '@/components/Atoms/Paper'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import { PropsWithChildren } from 'react'

interface ReadonlyButtonProps {
  tooltip?: string | React.ReactNode
  muted?: boolean
}

export function ReadonlyButton({
  tooltip,
  muted,
  children,
  className,
  ...props
}: PropsWithChildren<ReadonlyButtonProps> &
  React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Paper
          variant="outlined"
          className={cn(
            "flex h-8 shrink-0 items-center gap-2 px-3 text-sm font-medium has-[>svg]:px-3 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
            muted && 'text-muted-foreground [&_svg]:stroke-muted-foreground',
            className
          )}
          {...props}
        >
          {children}
        </Paper>
      </TooltipTrigger>
      {tooltip && <TooltipContent>{tooltip}</TooltipContent>}
    </Tooltip>
  )
}
